import React, { useState, memo, Component } from 'react';
import { useParams, Link } from 'react-router-dom';
import { CalendarIcon, UsersIcon, ClockIcon, MapPinIcon, CheckIcon, PhoneIcon, MessageSquareIcon, CreditCardIcon, BedIcon, UtensilsIcon, PlaneIcon, CarIcon } from 'lucide-react';
// Package data with detailed information
const packagesData = [{
  id: 1,
  title: 'Istanbul Explorer',
  image: 'https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1171&q=80',
  price: '$799',
  duration: '5 days',
  groupSize: '10 people',
  startDate: 'Multiple dates',
  destination: 'Turkey',
  featured: true,
  description: 'Experience the magic of Istanbul with our comprehensive 5-day tour package.',
  longDescription: 'Istanbul, where East meets West, is a fascinating city with a rich history that spans thousands of years. Our carefully crafted 5-day tour takes you through the most iconic landmarks including the Blue Mosque, Hagia Sophia, Topkapi Palace, and the Grand Bazaar. Experience a cruise on the Bosphorus, enjoy authentic Turkish cuisine, and immerse yourself in the vibrant culture of this magnificent city.',
  highlights: ['Visit the iconic Blue Mosque and Hagia Sophia', 'Explore the Grand Bazaar and Spice Market', 'Enjoy a scenic Bosphorus cruise', 'Tour the magnificent Topkapi Palace', 'Experience authentic Turkish cuisine', 'Guided walking tour of historic neighborhoods'],
  includes: ['Airport transfers', '4 nights accommodation in a 4-star hotel', 'Daily breakfast and 2 dinners', 'All entrance fees to attractions', 'English-speaking professional guide', 'Transportation in air-conditioned vehicles'],
  itinerary: [{
    day: 'Day 1',
    title: 'Arrival & Welcome',
    activities: 'Airport pickup, hotel check-in, welcome dinner with orientation briefing.'
  }, {
    day: 'Day 2',
    title: 'Historical Peninsula Tour',
    activities: 'Visit Blue Mosque, Hagia Sophia, Topkapi Palace, and the Underground Cistern.'
  }, {
    day: 'Day 3',
    title: 'Bosphorus & Markets',
    activities: 'Morning Bosphorus cruise, afternoon visit to Grand Bazaar and Spice Market.'
  }, {
    day: 'Day 4',
    title: 'Modern Istanbul & Local Neighborhoods',
    activities: 'Explore Taksim Square, Istiklal Street, and the trendy neighborhoods of Karakoy and Galata.'
  }, {
    day: 'Day 5',
    title: 'Departure',
    activities: 'Free morning for last-minute shopping or exploration, airport transfer.'
  }],
  gallery: ['https://images.unsplash.com/photo-1541432901042-2d8bd64b4a9b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1527838832700-5059252407fa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1298&q=80', 'https://images.unsplash.com/photo-1604941484653-49343a9a0387?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80']
}, {
  id: 2,
  title: 'Dubai Luxury Experience',
  image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
  price: '$1,299',
  duration: '7 days',
  groupSize: '8 people',
  startDate: 'Multiple dates',
  destination: 'Dubai',
  featured: true,
  description: 'Indulge in the ultimate luxury experience in the dazzling city of Dubai.',
  longDescription: "Dubai is a city that constantly pushes the boundaries of what's possible, from the world's tallest building to artificial islands shaped like palm trees. Our 7-day luxury package offers you the perfect blend of modern marvels and traditional Arabian culture. Stay in a 5-star hotel, experience the thrill of a desert safari, shop in the world's largest mall, and marvel at the architectural wonders that have made Dubai famous worldwide.",
  highlights: ['Visit the iconic Burj Khalifa with VIP access', 'Experience a luxury desert safari with dinner under the stars', 'Shop at the Dubai Mall and Gold Souk', 'Enjoy a private yacht cruise along Dubai Marina', 'Tour the historic Al Fahidi district', 'Day trip to Abu Dhabi including Ferrari World'],
  includes: ['VIP airport transfers in luxury vehicles', '6 nights accommodation in a 5-star hotel', 'Daily breakfast and 3 gourmet dinners', 'All entrance fees to attractions', 'English-speaking professional guide', 'Desert safari with BBQ dinner', 'Yacht cruise with refreshments'],
  itinerary: [{
    day: 'Day 1',
    title: 'Arrival & Luxury Welcome',
    activities: 'VIP airport pickup, hotel check-in, evening Dubai Marina yacht cruise with dinner.'
  }, {
    day: 'Day 2',
    title: 'Modern Dubai Tour',
    activities: 'Visit Burj Khalifa, Dubai Mall, Dubai Fountain show, and Burj Al Arab photo stop.'
  }, {
    day: 'Day 3',
    title: 'Desert Adventure',
    activities: 'Morning at leisure, afternoon luxury desert safari with dune bashing, camel riding, and BBQ dinner under the stars.'
  }, {
    day: 'Day 4',
    title: 'Traditional Dubai',
    activities: 'Explore Al Fahidi historical neighborhood, Dubai Creek, abra ride, and visit the Gold and Spice Souks.'
  }, {
    day: 'Day 5',
    title: 'Abu Dhabi Day Trip',
    activities: 'Full-day excursion to Abu Dhabi including Sheikh Zayed Grand Mosque, Louvre Abu Dhabi, and Ferrari World.'
  }, {
    day: 'Day 6',
    title: 'Leisure Day & Shopping',
    activities: 'Free day for shopping or optional activities like indoor skiing at Mall of Emirates or visiting Miracle Garden.'
  }, {
    day: 'Day 7',
    title: 'Departure',
    activities: 'Free time until departure, luxury airport transfer.'
  }],
  gallery: ['https://images.unsplash.com/photo-1582672752488-08797d00d8a8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1518684079-3c830dcef090?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1287&q=80', 'https://images.unsplash.com/photo-1584551246679-0daf3d275d0f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80']
}, {
  id: 3,
  title: 'Thailand Beach Getaway',
  image: 'https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1139&q=80',
  price: '$899',
  duration: '6 days',
  groupSize: '12 people',
  startDate: 'Multiple dates',
  destination: 'Thailand',
  featured: true,
  description: "Relax on pristine beaches and explore the natural beauty of Thailand's islands.",
  longDescription: "Thailand's southern islands are renowned worldwide for their stunning beaches, crystal-clear waters, and spectacular limestone formations. Our 6-day beach getaway takes you to the most beautiful islands including Phuket and Phi Phi Islands, where you can relax on white-sand beaches, swim in turquoise waters, explore hidden lagoons, and enjoy the vibrant nightlife. This perfect blend of relaxation and adventure will leave you with unforgettable memories of Thailand's tropical paradise.",
  highlights: ['Relax on the pristine beaches of Phuket', 'Island hopping tour to Phi Phi Islands', 'Snorkeling in crystal clear waters', 'Visit to James Bond Island', 'Thai cooking class', 'Traditional Thai massage'],
  includes: ['Airport transfers', '5 nights beachfront resort accommodation', 'Daily breakfast and 2 seafood dinners', 'Island hopping boat tours', 'Snorkeling equipment', 'English-speaking guide', 'Thai cooking class'],
  itinerary: [{
    day: 'Day 1',
    title: 'Arrival in Phuket',
    activities: 'Airport pickup, resort check-in, welcome dinner on the beach.'
  }, {
    day: 'Day 2',
    title: 'Phuket Island Tour',
    activities: "Explore Phuket's highlights including Big Buddha, Chalong Temple, and Patong Beach."
  }, {
    day: 'Day 3',
    title: 'Phi Phi Islands Adventure',
    activities: 'Full-day speedboat tour to Phi Phi Islands with snorkeling, beach time, and lunch.'
  }, {
    day: 'Day 4',
    title: 'James Bond Island Tour',
    activities: 'Explore Phang Nga Bay, James Bond Island, and kayaking through limestone caves.'
  }, {
    day: 'Day 5',
    title: 'Relaxation & Culture',
    activities: 'Morning Thai cooking class, afternoon free for beach time or optional Thai massage.'
  }, {
    day: 'Day 6',
    title: 'Departure',
    activities: 'Free time until departure, airport transfer.'
  }],
  gallery: ['https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1139&q=80', 'https://images.unsplash.com/photo-1537956965359-7573183d1f57?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1168&q=80', 'https://images.unsplash.com/photo-1490077476659-095159692ab5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1151&q=80']
}, {
  id: 4,
  title: 'Cappadocia Hot Air Balloon Tour',
  image: 'https://images.unsplash.com/photo-1570654230464-9cf63245bee7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
  price: '$1,099',
  duration: '4 days',
  groupSize: '8 people',
  startDate: 'Multiple dates',
  destination: 'Turkey',
  description: 'Float above the fairy chimneys and unique landscapes of Cappadocia.',
  longDescription: 'Cappadocia is famous for its surreal landscapes, fairy chimneys, and the magical experience of hot air ballooning at sunrise. Our 4-day tour gives you the opportunity to float above this unique landscape, explore underground cities, visit open-air museums, and stay in authentic cave hotels. This otherworldly destination offers a perfect blend of natural beauty, history, and adventure that will leave you with unforgettable memories.',
  highlights: ['Hot air balloon ride at sunrise over the fairy chimneys', 'Explore the Göreme Open Air Museum', 'Visit underground cities of Derinkuyu or Kaymakli', 'Hike through the Rose Valley and Pigeon Valley', 'Experience authentic cave hotel accommodation', 'Visit local pottery workshops in Avanos'],
  includes: ['Airport transfers', '3 nights cave hotel accommodation', 'Daily breakfast', 'Hot air balloon ride with champagne celebration', 'All entrance fees to attractions', 'English-speaking guide', 'Transportation in air-conditioned vehicles'],
  itinerary: [{
    day: 'Day 1',
    title: 'Arrival in Cappadocia',
    activities: 'Airport pickup, cave hotel check-in, afternoon visit to Uchisar Castle and Pigeon Valley.'
  }, {
    day: 'Day 2',
    title: 'Hot Air Balloon & North Cappadocia',
    activities: 'Early morning hot air balloon ride, followed by North Cappadocia tour including Göreme Open Air Museum, Pasabag (Monks Valley), and Devrent Valley.'
  }, {
    day: 'Day 3',
    title: 'South Cappadocia',
    activities: 'Full day exploring South Cappadocia including Derinkuyu Underground City, Ihlara Valley hike, and Selime Monastery.'
  }, {
    day: 'Day 4',
    title: 'Departure',
    activities: 'Free morning for optional activities or relaxation, airport transfer.'
  }],
  gallery: ['https://images.unsplash.com/photo-1570654230464-9cf63245bee7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80', 'https://images.unsplash.com/photo-1527838832700-5059252407fa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1298&q=80', 'https://images.unsplash.com/photo-1642419688758-221430be8b20?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80']
}, {
  id: 5,
  title: 'Kuala Lumpur City Break',
  image: 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
  price: '$699',
  duration: '4 days',
  groupSize: '10 people',
  startDate: 'Multiple dates',
  destination: 'Malaysia',
  description: 'Explore the vibrant city of Kuala Lumpur with its mix of modern and traditional attractions.',
  longDescription: "Kuala Lumpur, the capital city of Malaysia, is a vibrant metropolis where modern skyscrapers stand alongside colonial buildings and bustling street markets. Our 4-day city break allows you to experience the best of KL, from the iconic Petronas Twin Towers to the cultural diversity of its neighborhoods. Enjoy delicious Malaysian cuisine, explore colorful temples and mosques, and discover why this city is one of Southeast Asia's most exciting destinations.",
  highlights: ['Visit the iconic Petronas Twin Towers', 'Explore Batu Caves with its giant golden statue', 'Experience the vibrant markets of Chinatown', 'Visit the National Mosque and Islamic Arts Museum', 'Enjoy panoramic views from KL Tower', 'Day trip to historical Malacca'],
  includes: ['Airport transfers', '3 nights accommodation in a 4-star hotel', 'Daily breakfast', 'City tour with English-speaking guide', 'Entrance fees to attractions', 'Day trip to Malacca', 'Transportation in air-conditioned vehicles'],
  itinerary: [{
    day: 'Day 1',
    title: 'Arrival in Kuala Lumpur',
    activities: 'Airport pickup, hotel check-in, evening visit to Petronas Twin Towers observation deck.'
  }, {
    day: 'Day 2',
    title: 'KL City Tour',
    activities: 'Full-day city tour including National Monument, National Mosque, Sultan Abdul Samad Building, Chinatown, and KL Tower.'
  }, {
    day: 'Day 3',
    title: 'Malacca Day Trip',
    activities: 'Full-day excursion to the UNESCO World Heritage city of Malacca, exploring its colonial history and unique culture.'
  }, {
    day: 'Day 4',
    title: 'Batu Caves & Departure',
    activities: 'Morning visit to Batu Caves, free time for last-minute shopping, airport transfer.'
  }],
  gallery: ['https://images.unsplash.com/photo-1508098682722-e99c43a406b2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80', 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1164&q=80', 'https://images.unsplash.com/photo-1549981779-e08d9be8d7a5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80']
}, {
  id: 6,
  title: 'Phuket Island Hopping',
  image: 'https://images.unsplash.com/photo-1537956965359-7573183d1f57?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1168&q=80',
  price: '$849',
  duration: '5 days',
  groupSize: '12 people',
  startDate: 'Multiple dates',
  destination: 'Thailand',
  description: 'Explore the most beautiful islands around Phuket in this island-hopping adventure.',
  longDescription: "The Andaman Sea surrounding Phuket is home to some of the world's most beautiful islands and beaches. Our 5-day island hopping package allows you to explore the best of them, from the famous Phi Phi Islands to James Bond Island and the Similan Islands. Enjoy snorkeling in crystal-clear waters, relax on pristine beaches, and marvel at the limestone karsts that rise dramatically from the sea. This is the ultimate Thai island experience for beach lovers and water enthusiasts.",
  highlights: ['Island hopping to Phi Phi Islands, Maya Bay, and Bamboo Island', 'Excursion to James Bond Island and Phang Nga Bay', 'Snorkeling in crystal clear waters with colorful marine life', 'Relaxing on the beautiful beaches of Phuket', 'Optional day trip to Similan Islands (seasonal)', 'Experience vibrant nightlife at Patong Beach'],
  includes: ['Airport transfers', '4 nights beachfront hotel accommodation', 'Daily breakfast', 'Island hopping tours with lunch', 'Snorkeling equipment', 'English-speaking guide', 'Transportation in air-conditioned vehicles and speedboats'],
  itinerary: [{
    day: 'Day 1',
    title: 'Arrival in Phuket',
    activities: 'Airport pickup, hotel check-in, free evening to explore nearby beaches or relax.'
  }, {
    day: 'Day 2',
    title: 'Phi Phi Islands Tour',
    activities: 'Full-day speedboat tour to Phi Phi Islands, visiting Maya Bay, Pileh Lagoon, Monkey Beach, and snorkeling at coral reefs.'
  }, {
    day: 'Day 3',
    title: 'James Bond Island Tour',
    activities: 'Full-day tour to Phang Nga Bay, visiting James Bond Island, sea cave canoeing, and floating village of Koh Panyee.'
  }, {
    day: 'Day 4',
    title: 'Free Day or Optional Tour',
    activities: 'Free day to relax or optional tour to Similan Islands (seasonal) or Coral Island.'
  }, {
    day: 'Day 5',
    title: 'Departure',
    activities: 'Free time until departure, airport transfer.'
  }],
  gallery: ['https://images.unsplash.com/photo-1537956965359-7573183d1f57?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1168&q=80', 'https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1139&q=80', 'https://images.unsplash.com/photo-1468746587034-766ade47c1ac?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80']
}];
const PackageDetails = () => {
  const {
    id
  } = useParams();
  const packageId = parseInt(id || '1');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    travelers: '1',
    travelDate: '',
    message: '',
    specialRequirements: ''
  });
  const packageItem = packagesData.find(pkg => pkg.id === packageId);
  if (!packageItem) {
    return <div className="container mx-auto px-4 py-16 text-center" data-id="element-515">
        <h2 className="text-3xl font-bold text-gray-900" data-id="element-516">Package not found</h2>
        <Link to="/packages" className="mt-6 inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md" data-id="element-517">
          Back to Packages
        </Link>
      </div>;
  }
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Create message for WhatsApp
    const whatsappMessage = `Hello, I'm interested in booking the "${packageItem.title}" package.\n\n` + `Name: ${formData.name}\n` + `Email: ${formData.email}\n` + `Phone: ${formData.phone}\n` + `Number of Travelers: ${formData.travelers}\n` + `Preferred Travel Date: ${formData.travelDate || 'Flexible'}\n` + `Special Requirements: ${formData.specialRequirements || 'None'}\n\n` + `Additional Message: ${formData.message}`;
    // Open WhatsApp with the message
    window.open(`https://wa.me/96599886331?text=${encodeURIComponent(whatsappMessage)}`, '_blank');
  };
  return <div className="bg-white" data-id="element-518">
      {/* Hero Section */}
      <div className="relative bg-cover bg-center h-96" style={{
      backgroundImage: `url(${packageItem.image})`
    }} data-id="element-519">
        <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-520"></div>
        <div className="container mx-auto px-4 h-full flex items-center relative z-10" data-id="element-521">
          <div data-id="element-522">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-523">
              {packageItem.title}
            </h1>
            <p className="text-xl text-white max-w-2xl" data-id="element-524">
              {packageItem.description}
            </p>
            <div className="flex flex-wrap items-center mt-6 text-white gap-6" data-id="element-525">
              <div className="flex items-center" data-id="element-526">
                <ClockIcon size={20} className="mr-2" data-id="element-527" />
                <span data-id="element-528">{packageItem.duration}</span>
              </div>
              <div className="flex items-center" data-id="element-529">
                <UsersIcon size={20} className="mr-2" data-id="element-530" />
                <span data-id="element-531">Max {packageItem.groupSize}</span>
              </div>
              <div className="flex items-center" data-id="element-532">
                <MapPinIcon size={20} className="mr-2" data-id="element-533" />
                <span data-id="element-534">{packageItem.destination}</span>
              </div>
              <div className="flex items-center font-bold text-xl" data-id="element-535">
                <span data-id="element-536">
                  {packageItem.price}{' '}
                  <span className="text-sm font-normal" data-id="element-537">per person</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="container mx-auto px-4 py-16" data-id="element-538">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-539">
          {/* Left Column - Package Details */}
          <div className="lg:col-span-2" data-id="element-540">
            <div className="mb-10" data-id="element-541">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-542">
                Overview
              </h2>
              <p className="text-gray-700 mb-8 text-lg leading-relaxed" data-id="element-543">
                {packageItem.longDescription}
              </p>
            </div>
            <div className="mb-10" data-id="element-544">
              <h3 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-545">
                Highlights
              </h3>
              <ul className="space-y-3" data-id="element-546">
                {packageItem.highlights.map((highlight, index) => <li key={index} className="flex items-start" data-id="element-547">
                    <CheckIcon size={20} className="text-blue-600 mr-3 mt-1" data-id="element-548" />
                    <span className="text-gray-700" data-id="element-549">{highlight}</span>
                  </li>)}
              </ul>
            </div>
            <div className="mb-10" data-id="element-550">
              <h3 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-551">
                What's Included
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-552">
                {packageItem.includes.map((item, index) => <div key={index} className="flex items-start" data-id="element-553">
                    <CheckIcon size={20} className="text-green-600 mr-3 mt-1" data-id="element-554" />
                    <span className="text-gray-700" data-id="element-555">{item}</span>
                  </div>)}
              </div>
            </div>
            <div className="mb-10" data-id="element-556">
              <h3 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-557">
                Itinerary
              </h3>
              <div className="space-y-6" data-id="element-558">
                {packageItem.itinerary.map((day, index) => <div key={index} className="border-l-4 border-blue-600 pl-4 py-2" data-id="element-559">
                    <h4 className="font-bold text-lg text-gray-900" data-id="element-560">
                      {day.day}: {day.title}
                    </h4>
                    <p className="text-gray-700 mt-1" data-id="element-561">{day.activities}</p>
                  </div>)}
              </div>
            </div>
            <div className="mb-10" data-id="element-562">
              <h3 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-563">
                Gallery
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-564">
                {packageItem.gallery.map((image, index) => <div key={index} className="rounded-lg overflow-hidden" data-id="element-565">
                    <img src={image} alt={`${packageItem.title} - Image ${index + 1}`} className="w-full h-48 object-cover hover:scale-105 transition-transform duration-300" data-id="element-566" />
                  </div>)}
              </div>
            </div>
          </div>
          {/* Right Column - Booking Form */}
          <div data-id="element-567">
            <div className="bg-gray-50 p-6 rounded-lg shadow-md sticky top-8" data-id="element-568">
              <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-569">
                Book This Package
              </h3>
              <form onSubmit={handleSubmit} data-id="element-570">
                <div className="mb-4" data-id="element-571">
                  <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900" data-id="element-572">
                    Full Name
                  </label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" required data-id="element-573" />
                </div>
                <div className="mb-4" data-id="element-574">
                  <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900" data-id="element-575">
                    Email
                  </label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" required data-id="element-576" />
                </div>
                <div className="mb-4" data-id="element-577">
                  <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900" data-id="element-578">
                    Phone Number
                  </label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" required data-id="element-579" />
                </div>
                <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-580">
                  <div data-id="element-581">
                    <label htmlFor="travelers" className="block mb-2 text-sm font-medium text-gray-900" data-id="element-582">
                      Number of Travelers
                    </label>
                    <select id="travelers" name="travelers" value={formData.travelers} onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" data-id="element-583">
                      <option value="1" data-id="element-584">1 Person</option>
                      <option value="2" data-id="element-585">2 People</option>
                      <option value="3" data-id="element-586">3 People</option>
                      <option value="4" data-id="element-587">4 People</option>
                      <option value="5+" data-id="element-588">5+ People</option>
                    </select>
                  </div>
                  <div data-id="element-589">
                    <label htmlFor="travelDate" className="block mb-2 text-sm font-medium text-gray-900" data-id="element-590">
                      Preferred Date
                    </label>
                    <input type="date" id="travelDate" name="travelDate" value={formData.travelDate} onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" data-id="element-591" />
                  </div>
                </div>
                <div className="mb-4" data-id="element-592">
                  <label htmlFor="specialRequirements" className="block mb-2 text-sm font-medium text-gray-900" data-id="element-593">
                    Special Requirements (Optional)
                  </label>
                  <textarea id="specialRequirements" name="specialRequirements" rows={2} value={formData.specialRequirements} onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Dietary restrictions, accessibility needs, etc." data-id="element-594"></textarea>
                </div>
                <div className="mb-4" data-id="element-595">
                  <label htmlFor="message" className="block mb-2 text-sm font-medium text-gray-900" data-id="element-596">
                    Your Message
                  </label>
                  <textarea id="message" name="message" rows={3} value={formData.message} onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Any questions or specific details about your booking..." data-id="element-597"></textarea>
                </div>
                <button type="submit" className="w-full bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg text-sm px-5 py-3 text-center flex items-center justify-center" data-id="element-598">
                  <MessageSquareIcon size={18} className="mr-2" data-id="element-599" />
                  Book via WhatsApp
                </button>
              </form>
              <div className="mt-6 text-center" data-id="element-600">
                <p className="text-sm text-gray-600 mb-2" data-id="element-601">
                  Or contact us directly
                </p>
                <div className="flex justify-center space-x-4" data-id="element-602">
                  <a href="tel:0096599886331" className="flex items-center text-blue-600 hover:text-blue-800" data-id="element-603">
                    <PhoneIcon size={16} className="mr-1" data-id="element-604" />
                    <span data-id="element-605">Call Us</span>
                  </a>
                  <a href="https://wa.me/96599886331" className="flex items-center text-green-600 hover:text-green-800" data-id="element-606">
                    <MessageSquareIcon size={16} className="mr-1" data-id="element-607" />
                    <span data-id="element-608">WhatsApp</span>
                  </a>
                </div>
              </div>
              <div className="mt-8 pt-6 border-t border-gray-200" data-id="element-609">
                <h4 className="font-semibold text-gray-900 mb-3" data-id="element-610">
                  Package Includes:
                </h4>
                <div className="space-y-2" data-id="element-611">
                  <div className="flex items-center text-gray-700" data-id="element-612">
                    <PlaneIcon size={16} className="mr-2 text-blue-600" data-id="element-613" />
                    <span data-id="element-614">Flights</span>
                  </div>
                  <div className="flex items-center text-gray-700" data-id="element-615">
                    <BedIcon size={16} className="mr-2 text-blue-600" data-id="element-616" />
                    <span data-id="element-617">Accommodation</span>
                  </div>
                  <div className="flex items-center text-gray-700" data-id="element-618">
                    <UtensilsIcon size={16} className="mr-2 text-blue-600" data-id="element-619" />
                    <span data-id="element-620">Selected Meals</span>
                  </div>
                  <div className="flex items-center text-gray-700" data-id="element-621">
                    <CarIcon size={16} className="mr-2 text-blue-600" data-id="element-622" />
                    <span data-id="element-623">Transportation</span>
                  </div>
                  <div className="flex items-center text-gray-700" data-id="element-624">
                    <CreditCardIcon size={16} className="mr-2 text-blue-600" data-id="element-625" />
                    <span data-id="element-626">All Entrance Fees</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default PackageDetails;